import styled from 'styled-components';

export const CarouselCss = styled.div`
  background: #fff;

  @media (max-width: 720px) {
    background: ${(props) => (props.location ? '#000' : '#fff')};
  }

  .carousel.carousel-slider {
    cursor: ${(props) => props.cursor};
  }

  & .carousel .control-arrow,
  .carousel.carousel-slider .control-arrow {
    -webkit-transition: all 0.25s ease-in;
    -moz-transition: all 0.25s ease-in;
    -ms-transition: all 0.25s ease-in;
    -o-transition: all 0.25s ease-in;
    transition: all 0.25s ease-in;
    opacity: 0.4;
    filter: alpha(opacity=40);
    position: absolute;
    z-index: 2;
    top: 20px;
    background: none;
    border: 0;
    font-size: 32px;
  }

  & .carousel .control-arrow:hover {
    opacity: 1;
    filter: alpha(opacity=100);
  }

  & .carousel .control-arrow:before,
  & .carousel.carousel-slider .control-arrow:before {
    margin: 0 5px;
    display: inline-block;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    content: '';
  }

  & .carousel .control-disabled.control-arrow {
    opacity: 0;
    filter: alpha(opacity=0);
    cursor: inherit;
    display: none;
  }

  & .carousel .control-prev.control-arrow {
    left: 0;
  }

  & .carousel .control-prev.control-arrow:before {
    border-right: 8px solid #fff;
  }

  & .carousel .control-next.control-arrow {
    right: 0;
  }

  & .carousel .control-next.control-arrow:before {
    border-left: 8px solid #fff;
  }

  & .carousel-root {
    outline: none;
    display: flex;
    justify-content: space-between;

    @media (max-width: 720px) {
      display: block;
      cursor: default;
    }
  }

  & .carousel {
    position: relative;
    // width: 100%;

    @media (max-width: 720px) {
      width: 100%;
    }
  }

  & .carousel * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  & .carousel img {
    width: 100%;
    height: auto;
    display: inline-block;
    pointer-events: none;
  }

  & .carousel .carousel {
    position: relative;
  }

  & .carousel .control-arrow {
    outline: 0;
    border: 0;
    background: none;
    top: 50%;
    margin-top: -13px;
    font-size: 18px;
  }

  & .carousel .thumbs-wrapper {
    margin: 0px 20px 20px 0;
    overflow: hidden;
    height: 410px;
    scroll-behavior: smooth;
    @media (max-width: 720px) {
      height: auto;
      margin: 16px 20px;
    }
  }

  & .carousel .thumbs {
    transition: all 0.15s ease-in;

    position: relative;
    list-style: none;
    // white-space: nowrap;
    display: flex;
    flex-direction: column;
    @media (min-width: 720px) {
      transform: ${(props) =>
        props.verticleSlide
          ? `translate3d(0,${props.verticleSlide},0) !important`
          : 'translate3d(0, 0, 0) !important'};
    }

    @media (max-width: 720px) {
      display: block;
      white-space: nowrap;
      transform: translate3d(0, 0, 0);
    }
  }

  .verticleBottomButton {
    display: inline-block;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-left: 8px solid #00000070;
    background: transparent;
    border-right: none;
    transform: rotate(90deg);
    position: absolute;
    left: 25px;
    bottom: 82px;
    cursor: pointer;
    z-index: 99;

    @media (max-width: 720px) {
      left: 11px;
      bottom: 110px;
      transform: rotate(180deg);
      display: none;
    }

    &:hover {
      border-left: 8px solid #00000090;
    }
  }

  .verticleTopButton {
    display: inline-block;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-left: 8px solid #00000070;
    background: transparent;
    border-right: none;
    transform: rotate(270deg);
    position: absolute;
    left: 25px;
    z-index: 99;
    top: -4px;
    cursor: pointer;

    @media (max-width: 720px) {
      display: none;
    }

    &:hover {
      border-left: 8px solid #00000070;
    }
  }

  & .carousel .thumb {
    -webkit-transition: border 0.15s ease-in;
    -moz-transition: border 0.15s ease-in;
    -ms-transition: border 0.15s ease-in;
    -o-transition: border 0.15s ease-in;
    transition: border 0.15s ease-in;
    display: inline-block;
    margin: 6px 6px 6px 0;
    margin-right: 6px;
    white-space: nowrap;
    overflow: hidden;
    border: 3px solid #fff;
    padding: 2px;
    cursor: pointer;

    @media (max-width: 720px) {
      margin: 0 6px 0 0;
    }
  }

  & .carousel .thumb:focus {
    border: 3px solid #ccc;
    outline: none;
  }

  & .carousel .thumb.selected,
  .carousel .thumb:hover {
    border: 3px solid #333;
  }

  & .carousel .thumb img {
    vertical-align: top;
  }

  & .carousel.carousel-slider {
    position: relative;
    margin: 0;
  }

  & .carousel.carousel-slider .control-arrow {
    top: 0;
    color: #fff;
    font-size: 26px;
    bottom: 0;
    margin-top: 0;
    padding: 5px;
  }

  & .carousel.carousel-slider .control-arrow:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }

  & .carousel .slider-wrapper {
    overflow: hidden;
    margin: auto;
    width: 100%;
    -webkit-transition: height 0.15s ease-in;
    -moz-transition: height 0.15s ease-in;
    -ms-transition: height 0.15s ease-in;
    -o-transition: height 0.15s ease-in;
    transition: height 0.15s ease-in;
  }

  & .carousel .slider-wrapper.axis-horizontal .slider {
    -ms-box-orient: horizontal;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -moz-flex;
    display: -webkit-flex;
    display: flex;
    cursor: pointer;
  }

  & .carousel .slider-wrapper.axis-horizontal .slider .slide {
    flex-direction: column;
    flex-flow: column;
  }

  & .carousel .slider-wrapper.axis-vertical {
    -ms-box-orient: horizontal;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -moz-flex;
    display: -webkit-flex;
    display: flex;
  }

  & .carousel .slider-wrapper.axis-vertical .slider {
    -webkit-flex-direction: column;
    flex-direction: column;
  }

  & .carousel .slider {
    margin: 0;
    padding: 0;
    position: relative;
    list-style: none;
    width: 100%;
  }

  & .carousel .slider.animated {
    -webkit-transition: all 0.35s ease-in-out;
    -moz-transition: all 0.35s ease-in-out;
    -ms-transition: all 0.35s ease-in-out;
    -o-transition: all 0.35s ease-in-out;
    transition: all 0.35s ease-in-out;
  }

  & .carousel .slide {
    min-width: 100%;
    margin: 0;
    position: relative;
    text-align: center;
  }

  & .carousel .slide img {
    width: 100%;
    height: auto;
    vertical-align: top;
    border: 0;
  }

  & .carousel .slide iframe {
    display: inline-block;
    width: calc(100% - 80px);
    margin: 0 40px 40px;
    border: 0;
  }

  & .carousel .slide .legend {
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
    position: absolute;
    bottom: 40px;
    left: 50%;
    margin-left: -45%;
    width: 90%;
    border-radius: 10px;
    background: #000;
    color: #fff;
    padding: 10px;
    font-size: 12px;
    text-align: center;
    opacity: 0.25;
    -webkit-transition: opacity 0.35s ease-in-out;
    -moz-transition: opacity 0.35s ease-in-out;
    -ms-transition: opacity 0.35s ease-in-out;
    -o-transition: opacity 0.35s ease-in-out;
    transition: opacity 0.35s ease-in-out;
  }

  & .carousel .control-dots {
    position: absolute;
    bottom: -30px;
    margin: 10px 0;
    padding: 0;
    text-align: center;
    width: 100%;
  }

  & .carousel .control-dots .dot {
    -webkit-transition: opacity 0.25s ease-in;
    -moz-transition: opacity 0.25s ease-in;
    -ms-transition: opacity 0.25s ease-in;
    -o-transition: opacity 0.25s ease-in;
    transition: opacity 0.25s ease-in;
    opacity: 0.3;
    filter: alpha(opacity=30);
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.9);
    background: #63b0a8;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    cursor: pointer;
    display: inline-block;
    margin: 0 8px;
  }

  & .carousel .control-dots .dot.selected,
  .carousel .control-dots .dot:hover {
    opacity: 1;
    filter: alpha(opacity=100);
  }

  & .carousel .carousel-status {
    position: absolute;
    top: 0;
    right: 0;
    padding: 5px;
    font-size: 10px;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.9);
    color: #fff;
  }

  & .carousel:hover .slide .legend {
    opacity: 1;
  }
`;

export const CrossWhite = styled.img`
  display: none;
  @media (max-width: 720px) {
    display: block;
    width: ${(props) => (props.location ? '22px' : '15px')};
    height: ${(props) => (props.location ? '22px' : '15px')};
    margin-top: 14px;
    margin-left: 91%;
    position: fixed;
    z-index: 99;
  }
`;

export const CarouselCover = styled.div`
  background: #fff;
  position: sticky;
  top: 119px;

  .thumbs-wrapper {
    display: block;
  }

  .control-dots {
    display: none;
  }

  @media (max-width: 720px) {
    position: initial;
  }

  & .carousel .control-dots .dot {
    transition: opacity 0.2s ease;
    border-radius: 30px !important;
    background: #d6d6d6 !important;
    position: relative !important;
    box-shadow: none !important;
    opacity: 1;
  }

  & .carousel .control-dots .dot {
    margin: 0 6px;
  }

  & .carousel.carousel-slider {
    overflow: inherit !important;
  }

  & .carousel.carousel-slider {
    overflow: inherit !important;
    background-color: #fff !important;
    order: 1;

    @media (max-width: 720px) {
      order: 0;
      bakground-color: #fff !important;
      aspect-ratio: 16/16;
      max-width: 414px;
      margin: auto;
    }
  }

  & .carousel .control-dots {
    bottom: -34px;
    text-align: center;
    z-index: 2;
    width: 100%;
  }

  & .carousel .slide img {
    border-radius: 16px;

    @media (max-width: 720px) {
      border-radius: 0;
    }
  }

  & .carousel .control-dots .dot.selected,
  .carousel .control-dots .dot:hover {
    background: #ef4e5e !important;
  }

  & .selected span {
    color: #fff !important;
  }

  & .carousel .thumb {
    height: 69px;
    width: 69px !important;
    position: relative;
    padding: 0 !important;
    background-color: rgb(180, 175, 175);
    border: 0 !important;

    @media (max-width: 720px) {
      height: 80px;
      width: 80px !important;
    }
  }

  & .carousel .thumb {
    height: 69px;
    width: 69px !important;
    padding: 0 !important;
    border-radius: 4px;
    border: solid 1px #e5e5e5;
    margin-right: 12px;

    @media (max-width: 720px) {
      height: 80px;
      width: 80px !important;
    }
  }

  & .carousel .thumb.selected {
    border: 3px solid #ef4e5e !important;
    padding: 2px;
  }

  & .carousel .control-next.control-arrow:before {
    border-left: 8px solid #000;
    display: none;

    @media (max-width: 720px) {
      display: block;
      cursor: default !important;
    }
  }

  & .carousel .control-prev.control-arrow:before {
    border-right: 8px solid #000;
    display: none;

    @media (max-width: 720px) {
      display: block;
      cursor: default !important;
    }
  }
`;

export const TwoGrid = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.newpdp ? '48% 48%' : '46% 50%')};
  padding: 24px 24px 24px 0;
  justify-content: space-between;

  @media (max-width: 720px) {
    grid-template-columns: 100%;
    padding: 0;
  }
`;

export const CarouselPopupContainer = styled.div`
  display: ${(props) => (props.babyTrustUI ? 'block' : 'grid')};
  grid-template-columns: 55% 44%;
  justify-content: space-between;

  @media (max-width: 720px) {
    grid-template-columns: 100%;
  }

  & .carousel .thumb {
    height: 80px;
    padding: 0 !important;
    border-radius: 4px;
    border: solid 1px #e5e5e5;
    margin-right: 6px;
  }

  & .carousel .thumb.selected {
    border: 3px solid #ef4e5e;
    padding: 2px;
    border-radius: 4px;
  }

  & .carousel .thumbs {
    flex-direction: row !important;
    justify-content: center !important;
  }

  & .carousel .thumbs-wrapper {
    margin-top: 34px;
  }

  .carousel-root {
    flex-wrap: wrap;
  }

  & .carousel .control-dots .dot {
    transition: opacity 0.2s ease;
    border-radius: 30px !important;
    width: 2rem !important;
    height: 4px !important;
    background: #d6d6d6 !important;
    position: relative !important;
    box-shadow: none !important;
    opacity: 1;
  }

  .carousel .control-dots {
    position: relative !important;
    bottom: 0;
    margin: 10px 0;
    padding: 0;
    text-align: center;
    width: 100%;
  }

  & .carousel .control-dots .dot.selected,
  .carousel .control-dots .dot:hover {
    background: #869791 !important;
  }

  & .carousel .slide {
    background: none !important;
    max-height: 75vh !important;
  }

  & .carousel img {
    width: 100%;
    max-height: 78vh;
    display: inline-block;
    pointer-events: none;
    object-fit: contain;

    @media (max-width: 720px) {
      max-height: 75vh;
    }
  }

  & .carousel .thumb img {
    max-height: 80px;
    max-width: 80px;
    object-fit: contain !important;
  }

  & .carousel > .control-prev.control-arrow {
    left: 8px;
    background-image: url('/images/LHS.svg') !important;
    background-repeat: no-repeat !important;
    top: 50%;
    transform: translate(0, -50%);
    width: 30px;
    height: 30px;
    background-size: 30px;
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }

  & .carousel > .control-next.control-arrow {
    right: 8px;
    background-image: url('/images/RHS.svg') !important;
    background-repeat: no-repeat !important;
    top: 50%;
    transform: translate(0, -50%);
    width: 30px;
    height: 30px;
    background-size: 30px;
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }

  & .carousel .control-next.control-arrow:before {
    border: none !important;
  }

  & .carousel .control-prev.control-arrow:before {
    border: none !important;
  }

  & .carousel .control-arrow,
  .carousel.carousel-slider .control-arrow {
    opacity: 1 !important;
    position: absolute !important;
    z-index: 2 !important;
    border: 0 !important;
    border-radius: 50% !important;
  }
`;
export const CarouselPopupCover = styled.div`
  z-index: 1000;
  height: ${(props) => (props.newImagePopup ? 'auto' : '100vh')};
  width: 100%;
  background: #fff;
  position: ${(props) => (props.newImagePopup ? 'static' : 'fixed')};
  top: 0;
  left: 0;

  @media (max-width: 720px) {
    width: 100vw;
    height: 100vh;
    position: fixed;
    background: ${(props) => (props.location ? '#000' : '#fff')};
  }
`;
export const CarouselZoomPopup = styled.div`
  height: 100vh;
  width: 100%;
  background: #f6f6f6;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;

  @media (max-width: 720px) {
    width: 100vw;
    z-index: 100;
  }
  @media (min-width: 720px) {
    justify-content: space-around;
  }
`;

export const CrossButton = styled.span`
  position: absolute;
  top: 30px;
  right: 12px;
  font-size: 36px;
  font-weight: 400;
  z-index: 99;

  @media (min-width: 720px) {
    cursor: pointer;
  }
`;

export const PrevArrow = styled.span`
  position: absolute;
  top: 45%;
  left: 15px;
  z-index: 99;

  img {
    width: 22px;
    height: auto;
    transform: rotate(90deg);
  }

  @media (min-width: 720px) {
    cursor: pointer;
  }
`;

export const NextArrow = styled(PrevArrow)`
  right: 15px;
  left: auto;

  img {
    transform: rotate(270deg);
  }
`;

export const Tooltip = styled.div`
  width: max-content;
  background-color: ${(props) => props.color};
  left: 10px;
  position: absolute;
  bottom: 10px;
  display: flex;
  align-items: center;
  padding: 5px 10px 5px 9px;
  font-size: 12px;
  border-radius: 4px;
  box-shadow: rgb(0 0 0 / 16%) 0px 1px 2px 0px;
`;
export const TooltipImage = styled.img`
  width: 16px !important;
  height: 16px !important;
  margin-right: 4px !important;
`;

export const ThumbnailScrollableSec = styled.div`
  display: flex;
  overflow: auto;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 720px) {
    justify-content: center;
  }
`;

export const CarouselPopupBackground = styled.div`
  height: calc(100vh - 160px);
  width: 100%;
  display: flex;
  align-items: center;
  background: ${(props) => (props.color ? props.color : `#000`)};

  @media (max-width: 720px) {
    // height: calc(100vh - 220px);
  }
`;
